export default {
      id: "acc-usage",
      viewBox: "0 0 38.5 43.2",
      url: __webpack_public_path__ + "img/icons.da3a4c09.svg#acc",
      toString: function () {
        return this.url;
      }
    }